import { ANALYTICS_SCREEN_NAMES } from 'common/constants';
import { useLocation } from 'react-router-dom';

// This hook is used to get humanized screen names for analytics
export const useGetScreenForAnalytics = () => {
  const { pathname } = useLocation();

  // get first path segment (eg. "/benefits#subsection/some-id" -> "benefits")
  const primaryPath = pathname.match(/^\/([^/#]+)/)?.[1];

  const {
    HOME,
    BENEFITS_LANDING,
    CARE_LANDING,
    JOURNEY_LANDING,
    SUPPORT_LANDING,
  } = ANALYTICS_SCREEN_NAMES;

  // these strings are intentionally non-translated
  switch (primaryPath) {
    case 'home':
      return HOME;
    case 'benefits':
      return BENEFITS_LANDING;
    case 'care-discovery':
      return CARE_LANDING;
    case 'health-journey':
      return JOURNEY_LANDING;
    case 'support':
      return SUPPORT_LANDING;
    default:
      return `${primaryPath?.replace(/-/g, ' ')} screen`;
  }
};
